import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useState } from "react";
import * as Utils from "./Utils";

/**
 * Session information for an authenticated user.
 */
var info;
/**
 * Listeners which will be called any time the session information changes.
 */
var listeners = [];
function get() {
  return info;
}
function set(sessionInfo) {
  info = sessionInfo;
  listeners.forEach(function (listener) {
    return listener(info);
  });
}
export function clear() {
  info = null;
  listeners.forEach(function (listener) {
    return listener(info);
  });
}
export function getUsername() {
  if (info) {
    return info.username;
  }
  return "Unknown";
}

/**
 * Fetches the session info from the server.
 * @param callback optional callback
 */
export function refresh(callback) {
  Utils.fetchData("application/auth/sessionInfo").then(function (data) {
    set(data);
    if (callback) {
      callback(data);
    }
  }).catch(function (error) {
    set(null);
    if (callback) {
      callback(null);
    }
  });
}
function addListener(listener) {
  listeners.push(listener);
}
function removeListener(listener) {
  listeners = listeners.filter(function (aListener) {
    return aListener !== listener;
  });
}

/**
 * Hook used to access and change session info.
 */
export function useSessionInfo() {
  var _useState = useState(get()),
    _useState2 = _slicedToArray(_useState, 2),
    sessionInfo = _useState2[0],
    setSessionInfo = _useState2[1];

  /**
   * Reset the listener anytime the setter method changes.
   */
  useEffect(function () {
    addListener(setSessionInfo);
    return function () {
      removeListener(setSessionInfo);
    };
  }, [setSessionInfo]);

  /**
   * Update the cached session info anytime it's changed.
   */
  useEffect(function () {
    set(sessionInfo);
  }, [sessionInfo]);
  return [sessionInfo, setSessionInfo];
}